// @flow
import * as React from 'react';
import { Card, Metric } from 'statsradio/themes/v3/Stylesheet';
import styled from 'styled-components';
import { Numeric } from 'common/components/Number';

const ROUNDING_PRECISION = 0;

const MetricCard = styled(Card)`
  flex-direction: column;
  padding: ${props => props.theme.V3.metrics.margin.small}px 0px;
  text-align: center;
  width: 50%;
`;

interface Props {
  color: string;
  label: string;
  suffix: string;
  value: Number;
}

export default function DashboardMetricCard({ color, label, suffix, value }: Props) {
  return (
    <MetricCard>
      <h4>{label}</h4>
      <Metric color={color}>
        <Numeric value={value} roundAt={ROUNDING_PRECISION} suffix={suffix} />
      </Metric>
    </MetricCard>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/metrics/DashboardMetricCard.js